<template>
	<div>

		<b-row>
			<b-col>
				<b-row align-h="start">
					<b-col v-if="type == 'stock'" :cols="isMobile() ? 12 : 3" md="auto"
						style="padding-right: 2px; min-width: 200px">
						<b-form-datepicker id="start" v-model="startDate" size="md" :locale="locale" class="mb-2"
							today-variant="danger" placeholder="-" :start-weekday="weekday" :date-format-options="{
								year: 'numeric',
								month: 'numeric',
								day: 'numeric',
							}" />
					</b-col>
					<b-col v-if="type == 'stock'" :cols="isMobile() ? 12 : 3" md="auto"
						style="padding-right: 2px; min-width: 200px">
						<b-form-datepicker id="end" v-model="endDate" size="md" :locale="locale" class="mb-2" today-variant="danger"
							placeholder="-" :start-weekday="weekday" :date-format-options="{
								year: 'numeric',
								month: 'numeric',
								day: 'numeric',
							}" />
					</b-col>
					<b-col v-if="type == 'stock'" :cols="isMobile() ? 12 : 3" md="auto">
						<b-button style="border-color: white" v-on:click="editStockTrans()" size="sm"
							class="vs-con-loading__container bg-primary" id="loading-stock-list">
							<Icon icon="ph:list-fill" style="margin-right: 5px" width="20" height="20" />{{ $t("ListStockTrans") }}
						</b-button>
					</b-col>
				</b-row>
			</b-col>
			<b-col>
				<b-row align-h="end">
					<b-col cols="3" md="auto">
						<b-dropdown size="sm" id="dropdown-1" :text="$t('TotalActions')" class="bg-primary"
							style="border-color: white">
							<b-dropdown-item-button @click="
								wholeStockActions = true;
							printBarcodeControl();
							">
								<span class="flex items-center">
									<feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" class="mr-2" />
									<span>{{ $t("PrintBarcode") }}</span>
								</span>
							</b-dropdown-item-button>
						</b-dropdown>
					</b-col>
				</b-row>
			</b-col>


		</b-row>
		<ag-grid-vue class="scroll-to-ag-grid-table-stock-move-detail ag-theme-alpine w-100 my-4 ag-grid-table"
			:suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="stockTransDetailClmn"
			:rowData="stockTransDetail" :localeText="localeText" @grid-ready="onGridReadyStTr" rowSelection="multiple">
		</ag-grid-vue>
		<vs-popup class="holamundo" :title="$t('StocktransPrice') + ' (' + SerialNumber + ') '"
			:active.sync="isSstocktransEditPopup">
			<div>
				<b-row style="margin-top: 8px">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('CurrentPrice')" label-for="h-first-name" style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="CurrentPrice" type="text" class="w-full" name="CurrentPrice" />
					</b-col>
				</b-row>
				<b-row style="margin-top: 8px">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('CurrentPriceCode')" label-for="h-first-name" style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="CurrentPriceCode" type="text" class="w-full" name="CurrentPriceCode" />
					</b-col>
				</b-row>
				<b-row style="margin-top: 8px">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('LocalCurrentPrice')" label-for="h-first-name" style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="LocalCurrentPrice" type="text" class="w-full" name="LocalCurrentPrice" />
					</b-col>
				</b-row>
				<b-row style="margin-top: 8px">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('LocalCurrentCode')" label-for="h-first-name" style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="LocalCurrentCode" type="text" class="w-full" name="LocalCurrentCode" />
					</b-col>
				</b-row>

				<b-row style="margin-top: 8px">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('SellerPrice')" label-for="h-first-name" style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="SellerPrice" type="text" class="w-full" name="SellerPrice" />
					</b-col>
				</b-row>
				<b-row style="margin-top: 8px">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('SellerCurrentCode')" label-for="h-first-name" style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="SellerCurrentCode" type="text" class="w-full" name="SellerCurrentCode" />
					</b-col>
				</b-row>
				<b-col style="text-align: end">
					<b-button style="border-color: white" v-on:click="submitTransDetail()" class="bg-primary">
						{{ $t("Save") }}
					</b-button>
				</b-col>
			</div>
		</vs-popup>
		<vs-popup class="holamundo" :title="$t('PrintBarcode')" :active.sync="isSidebarActiveBarcodePrintTemp"
			@close="printBarcode" @cancel="printBarcode" fullscreen>
			<BarcodePrintingTamplate :isSidebarActive="isSidebarActiveBarcodePrintTemp" :name="'serialNumberTemplate'"
				:data="printAcceptedValues" @closeSidebar="printBarcode" />
			<vs-prompt :title="$t('Submit')" :acceptText="$t('Delete')" :cancelText="$t('Cancel')" @accept="transPriceDelete"
				:active.sync="activePromptToTransPrice" color="danger">
				<div class="con-exemple-prompt">
					<b-row style="align-items: center">
						<b-col lg="12">
							<span>{{ $t("ConfirmToUpdateList") }} {{ $t("AreYSure") }}
								{{ $t("CantUndo") }}</span>
						</b-col>
					</b-row>
				</div>
			</vs-prompt>
		</vs-popup>
	</div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import i18nData from "../../i18n/i18nData";
import twoInfoButtonsDynamic from "../CellRenderers/twoInfoButtonsDynamic.vue";
import BarcodePrintingTamplate from "../components/global-components/BarcodePrintingTamplate.vue";
import { isMobile } from "mobile-device-detect";
import { Icon } from "@iconify/vue2";

export default {
	props: {
		data: {
			default: () => { },
		},
		type: {
			default: () => "",
		},
	},
	components: {
		Icon,
		BarcodePrintingTamplate,
		AgGridVue,
		twoInfoButtonsDynamic,
	},
	data() {
		return {
			locale: "de",
			weekday: 1,
			isMobile: function () {
				return isMobile;
			},
			TransCode: "",
			StockTrasnId: "",
			CurrentPrice: "",
			CurrentPriceCode: "",
			LocalCurrentCode: "",
			LocalCurrentPrice: "",
			SellerCurrentCode: "",
			SellerPrice: "",
			SerialNumber: "",
			StockTransPriceInfoId: "",
			isSstocktransEditPopup: false,
			activePromptToTransPrice: false,
			isSidebarActiveBarcodePrintTemp: false,
			stockTransDetailClmn: [],
			endDate: "",
			startDate: "",
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true,
			},
			columns: [],
			printAcceptedValues: [],
			infoData: [],
			infoDataDelete: [],
			infoDataEdit: [],
		};
	},
	methods: {
		submitTransDetail() {
			const vs = this.$vs;
			let obj = {
				stockTransPriceId: this.StockTransPriceInfoId,
				localCurrentCode: this.LocalCurrentCode,
				localCurrentPrice: this.LocalCurrentPrice,
				currentPriceCode: this.CurrentPriceCode,
				currentPrice: this.CurrentPrice,
				sellerCurrentCode: this.SellerCurrentCode,
				sellerPrice: this.SellerPrice,
				stockTransId: this.StockTrasnId,
				stockTransCode: this.TransCode,
			};
			this.$store
				.dispatch("stock/updateStockTransPrice", obj)
				.then((response) => {
					if (response.status == 200) {
						vs.notify({
							text: response.data.message,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "success",
							position: "top-center",
						});
						this.editStockTrans();
						this.isSstocktransEditPopup = false;
					} else {
						vs.notify({
							text: response.data[0].value.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					}
				})
				.catch((error) => {
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		parseDate(params) {
			return moment(String(params)).format("YYYY-MM-DD");
		},
		editStockTrans() {
			const vs = this.$vs;
			let method = "",
				dataItem = "";
			this.startDate =
				this.startDate == ""
					? this.parseDate(new Date(new Date().setDate(new Date().getDate() - 30)))
					: this.parseDate(moment(String(this.startDate)).format("MM.DD.YYYY"));
			this.endDate =
				this.endDate == ""
					? this.parseDate(new Date(new Date().setDate(new Date().getDate() + 1)))
					: this.parseDate(moment(String(this.endDate)).format("MM.DD.YYYY"));
			console.log(this.startDate)
			if (this.type == "head") {
				method = "listStockTransDetail";
				dataItem = this.data.StockTransCode;
			} else if (this.type == "stock") {
				method = "listStockTransForStock";
				dataItem = {
					companyId: this.data.CompanyId,
					stockId: this.data.StockId,
					startDate: moment(String(this.startDate)).format("MM.DD.YYYY"),
					endDate: moment(String(this.endDate)).format("MM.DD.YYYY"),
				};
			} else if (this.type == "stock2") {
				method = "listStockTransForStock";
				dataItem = {
					companyId: this.data.companyId,
					stockId: this.data.StockId,
					startDate: moment(String(this.startDate)).format("MM.DD.YYYY"),
					endDate: moment(String(this.endDate)).format("MM.DD.YYYY"),
				};
			}
			console.log(dataItem)
			this.$store
				.dispatch("stock/" + method, dataItem)
				.then((response) => {
					if (response.success == true) {
						try {
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		onGridReadyStTr(params) {
			this.gridApiStTr = params.api;
			this.gridColumnApiStTr = params.columnApi;
			var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
			params.columnApi.applyColumnState({ state: defaultSortModel });
			this.gridApiStTr.refreshCells(params);
		},
		printBarcodeControl() {
			this.printAcceptedValues = [];
			var selectedRows = this.gridApiStTr.getSelectedRows();
			selectedRows.forEach((val, index) => {
				console.log(val)
				if (val.SerialInfo)
					this.printAcceptedValues.push({
						serialNo: val.SerialInfo.SerialNumber,
						SupplierCode: val.SupplierCode,
						SupplierName: val.SupplierName,
						StockName: val.StockName,
						stockName: val.StockName,
						companyId: val.CompanyId,
						Barcode: val.Barcode,
						CompanyId: val.CompanyId,
						CompanyName: val.CompanyName,
						CreateDate: val.CreateDate,
						DepotName: val.DepotName,
						Description: val.Description,
						GroupCode: val.GroupCode,
						QEntery: val.QEntery,
						QExit: val.QExit,
						SpecCode1: val.SpecCode1,
						SpecCode2: val.SpecCode2,
						TransCode: val.TransCode,
						TransDate: val.TransDate,
						TrasnType: val.TrasnType,
					});
			});
			if (this.printAcceptedValues.length > 0) this.printBarcode(true);
			else {
				const vs = this.$vs;

				vs.notify({
					text: this.$t("Validate"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "success",
					position: "top-center",
				});
			}
		},
		printBarcode(val = false) {
			this.isSidebarActiveBarcodePrintTemp = val;
		},
		getStockTransColumnList() {
			this.stockTransDetailClmn = [];
			this.stockTransDetail.forEach((val, index) => {
				if (val.SerialInfo) {
					this.stockTransDetail[index].SerialNumber = val.SerialInfo.SerialNumber;
					this.stockTransDetail[index].LocalCurrentPrice =
						val.SerialInfo.LocalCurrentPrice;
					this.stockTransDetail[index].LocalCurrentCode = val.SerialInfo.LocalCurrentCode;
					this.stockTransDetail[index].CurrentPrice = val.SerialInfo.CurrentPrice;
					this.stockTransDetail[index].CurrentPriceCode = val.SerialInfo.CurrentPriceCode;
				}
			});
			if (this.stockTransDetail.length > 0) {
				let columnList = Object.keys(this.stockTransDetail[0]);
				this.stockTransDetailClmn.push({
					headerCheckboxSelection: true,
					checkboxSelection: true,
					showDisabledCheckboxes: true,
					pinned: "left",
					width: 130,
					pinned: "left",
					cellRendererFramework: "twoInfoButtonsDynamic",
					cellRendererParams: {
						detailMethodsOne: "transPriceDelete",
						iconDetailOne: "ic:baseline-remove-circle",
						iconColorOne: "#fe6d73",
						tooltipOne: "TransPriceDelete",
						detailMethodsTwo: "transPriceEdit",
						iconDetailTwo: "material-symbols:edit",
						iconColorTwo: "#17c3b2",
						tooltipTwo: "TransPriceEdit",
					},
				});
				columnList.forEach((val, index) => {
					if (
						(val == "CompanyName" ||
							val == "Barcode" ||
							val == "QEntery" ||
							val == "QExit" ||
							val == "SerialNumber") &&
						!this.isMobile()
					) {
						this.stockTransDetailClmn.push({
							pinned: "left",
							headerName: this.$t(val),
							field: val,
							filter: "agSetColumnFilter",
						});
					} else if (val == "TrasnType") {
						this.stockTransDetailClmn.push({
							cellRendererFramework: "getShelfTransStatus",
							headerName: this.$t(val),
							field: val,
							filter: "agSetColumnFilter",
						});
					} else if (val.toString().includes("Date") == true)
						this.stockTransDetailClmn.push({
							headerName: this.$t(val),
							field: val,
							filter: "agSetColumnFilter",
							valueFormatter: (params) => this.parseDate(params.data[val]),
							editable: true,
						});
					else if (val.toString().includes("Id") == false) {
						this.stockTransDetailClmn.push({
							headerName: this.$t(val),
							field: val,
							filter: "agSetColumnFilter",
						});
					}
				});
			}
		},
		transPriceDelete() {
			const vs = this.$vs;
			this.$store
				.dispatch(
					"stock/deleteStockTransPrice",
					this.infoDataDelete.SerialInfo.StockTransPriceInfoId
				)
				.then((response) => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							this.dataItem();
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		transPriceEdit() {
			this.CurrentPrice = this.infoDataEdit.SerialInfo.CurrentPrice;
			this.CurrentPriceCode = this.infoDataEdit.SerialInfo.CurrentPriceCode;
			this.LocalCurrentCode = this.infoDataEdit.SerialInfo.LocalCurrentCode;
			this.LocalCurrentPrice = this.infoDataEdit.SerialInfo.LocalCurrentPrice;
			this.SellerCurrentCode = this.infoDataEdit.SerialInfo.SellerCurrentCode;
			this.SellerPrice = this.infoDataEdit.SerialInfo.SellerPrice;
			this.SerialNumber = this.infoDataEdit.SerialInfo.SerialNumber;
			this.StockTransPriceInfoId = this.infoDataEdit.SerialInfo.StockTransPriceInfoId;
			this.StockTrasnId = this.infoDataEdit.StockTrasnId;
			this.TransCode = this.infoDataEdit.TransCode;
			this.isSstocktransEditPopup = true;
		},
	},
	mounted() {
		if (this.data.length > 0) this.editStockTrans();

		this.$root.$on("transPriceDelete", (data) => {
			this.infoDataDelete = data;
			this.activePromptToTransPrice = true;
		});
		this.$root.$on("transPriceEdit", (data) => {
			this.infoDataEdit = data;
			this.transPriceEdit(true);
		});
	},
	beforeDestroy() {
		this.$root.$off("transPriceDelete");
		this.$root.$off("transPriceEdit");
	},
	computed: {
		localeText() {
			return i18nData[this.$i18n.locale];
		},
		stockTransDetail: {
			get() {
				return this.$store.state.stock.StockTransDetail;
			},
			set(val) {
				if (!val) {
				}
			},
		},
	},
	watch: {
		type(val) {
			return val;
		},
		data(val) {
			this.editStockTrans();
			return val;
		},
		stockTransDetail(val) {
			this.getStockTransColumnList();
			return val;
		},
	},
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table-stock-move-detail {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 95px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>
<style lang="scss">
[dir] .btn-group button {
	padding: 4px !important;
}
</style>
